import { Heart as FeatherHeart, Menu as FeatherMenu } from 'react-feather';
import { dividerStyles, fontStyles, globalStyles, iconStyles } from 'styles/theme';
import styled, { CSSObject } from '@emotion/styled';

import { Badge as AntdBadge } from 'antd';
import FlexContainer from 'components/common/FlexContainer';
import { Link as RectDOMLink } from 'react-router-dom';
import { mobileMediaQuery } from 'utils/common';

export const Container = styled(FlexContainer)({
  borderBottom: `1px solid ${dividerStyles.colors.primary}`,
  background: globalStyles.colors.white,
});

export const InnerContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '16px 10%',
  [mobileMediaQuery]: {
    margin: '16px 5%',
  },
});

export const LeftContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 16,
});

export const RightContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 32,
});

export const Divider = styled.div({
  backgroundColor: dividerStyles.colors.primary,
  width: '1px',
  height: 24,
});

export const NavbarItem = styled.li({
  '& a': {
    color: fontStyles.colors.primary,
  },
  listStyleType: 'none',
});

export const Link = styled(RectDOMLink)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 8,
});

export const iconCSS: CSSObject = {
  color: iconStyles.colors.primary,
  width: 20,
  height: 20,
};

export const Menu = styled(FeatherMenu)(iconCSS);

export const ImageIcon = styled.img(iconCSS);

export const Heart = styled(FeatherHeart)({
  color: iconStyles.colors.primary,
});

export const Badge = styled(AntdBadge)({
  lineHeight: 'initial',
});

export const NavParent = styled.ul({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 32,
  padding: 0,
  margin: 0,
});
